






















import {Vue, Prop, Component, Watch } from 'vue-property-decorator'
import Destination from '../models/Destination';
@Component({
    components: {

    }
})
export default class DestinationSelector extends Vue {

  @Prop({ default: null }) organizationId: string | null;

get routeDestinationId(): number {
    return parseInt(this.$store.state.route.params.destinationId, 10);
}

get selectedDestination() {
  if (isNaN(this.routeDestinationId)) {
    return null;
  }
  return this.destinations.find(d => d.id === this.routeDestinationId);
}

get destinations(): Destination[] {
  if (this.organizationId) {
    return (this.$store.state.destination.destinations as Destination[]).filter(d => d.organizationId === this.organizationId);
  }
  return this.$store.state.destination.destinations;
}

destinationFilter(e: Destination) {
  this.$emit('input', e.id)
}

}
